module.exports = __webpack_public_path__ + "assets/brand-carbon-filter.acb34bcb.svg";